<template>
  <div>
    <div v-if="!isProductEmpty">
      <card
        v-for="card in filteredList"
        :key="card.type"
        :id="card.id"
        :type="card.type"
        :description="card.description"
        :image="card.image"
        :quantity_kg="card.quantity_kg"
        :quantity_plate="card.quantity_plate"
        :quantity_unity="card.quantity_unity"
        @excluirCard="prepararExclusao(card.id)"
      />
    </div>
    <p v-else-if="isSearchEmpty" class="message-no-clients-filtered mt-5">
      Não há produtos cadastrados.
    </p>
    <p v-else class="message-no-clients-filtered mt-5">
      Não há produto cadastrado com o nome '{{ searchValue }}'
    </p>
    <Modalconfirmationdelete @exclusaoConfirmada="removerCard" />
  </div>
</template>

<script>
import Card from './Card.vue';
import { RemoveProduct } from '../../services/Product';
import showError from '../../utils/showError';
import Modalconfirmationdelete from '../ModalConfirmationDelete.vue';

export default {
  components: {
    Card,
    Modalconfirmationdelete,
  },
  props: {
    cards: {
      type: Array,
      required: true,
    },
    searchValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cardToDeleteId: null,
    };
  },
  methods: {
    prepararExclusao(id) {
      this.cardToDeleteId = id;
      this.$bvModal.show('modal-confirmation-delete');
    },
    removerCard() {
      if (this.cardToDeleteId != null) {
        RemoveProduct(this.cardToDeleteId)
          .then(() => {
            this.$toasted.global.defaultSuccess();
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch(showError);
        this.cardToDeleteId = null;
      }
    },
  },

  computed: {
    filteredList() {
      if (this.searchValue) {
        const toLowerCase = this.searchValue.toLowerCase();
        return this.cards.filter((card) =>
          card.type.toLowerCase().includes(toLowerCase)
        );
      }
      return this.cards;
    },
    isProductEmpty() {
      return this.filteredList.length === 0;
    },
    isSearchEmpty() {
      return this.searchValue === '';
    },
  },
};
</script>
